@if (isContentLoading) {
<div class="app-loading-container">
  <mat-spinner></mat-spinner>
</div>
} @else {
<!-- Page Header -->
<app-page-header title="Hozzáféréseim">
  Itt tudsz hozzáférést vásárolni, amit utána manuálisan kioszthatsz a tanulóknak
</app-page-header>

<!-- Practical module packages -->
<div class="package-type-section">
  <div class="packages-title text-gray-800"> Forgalmi hozzáférések </div>
  <div class="packages-definitions-list">
    @for (packageDefinition of practicePackageDefinitions; track packageDefinition) {
    <app-package-definition-card [packageDefinition]="packageDefinition" class="package-definition-card"
      (handleOutButtonClick)="loadPackageDefinitions()"></app-package-definition-card>
    }
    @if (practicePackageDefinitions.length === 0) {
    <div class="no-available-package-type">
      Nincs elérhető hozzáférés típus.
    </div>
    }
  </div>
</div>
<!-- Theory module packages -->
<div class="package-type-section">
  <div class="packages-title"> Elméleti hozzáférések </div>
  <div class="packages-definitions-list">
    @for (packageDefinition of theoryPackageDefinitions; track packageDefinition) {
    <app-package-definition-card [packageDefinition]="packageDefinition" class="package-definition-card"
      (handleOutButtonClick)="loadPackageDefinitions()"></app-package-definition-card>
    }
    @if (theoryPackageDefinitions.length === 0) {
    <div class="no-available-package-type">
      Nincs elérhető hozzáférés típus.
    </div>
    }
  </div>
</div>
<!-- Misc packages packages -->
@if (miscPackageDefinitions.length > 0) {
<div class="package-type-section">
  <div class="packages-title"> Egyéb hozzáférések </div>
  <div class="packages-definitions-list">
    @for (packageDefinition of miscPackageDefinitions; track packageDefinition) {
    <app-package-definition-card [packageDefinition]="packageDefinition" class="package-definition-card"
      (handleOutButtonClick)="loadPackageDefinitions()"></app-package-definition-card>
    }
  </div>
</div>
}
<!-- Inactice packages -->
@if (inactivePackageDefinitions.length > 0) {
<div class="package-type-section">
  <div class="packages-title"> Inaktív hozzáférések </div>
  <div class="inactive-packages-description">
    Az itt található hozzáférések már nem vásárolhatóak, de még kioszthatod őket.
  </div>
  <div class="packages-definitions-list">
    @for (packageDefinition of inactivePackageDefinitions; track packageDefinition) {
    <app-package-definition-card [packageDefinition]="packageDefinition" [isPurchaseAvailable]="false"
      class="package-definition-card" (handleOutButtonClick)="loadPackageDefinitions()"></app-package-definition-card>
    }
  </div>
</div>
}
}
